import * as stateNames from 'constants/states'
import * as actionTypes from 'constants/actionTypes'
import createThunkReducer from 'utils/createThunkReducer'

export default {
  [stateNames.ROLES_CREATE]: createThunkReducer(actionTypes.ROLES_CREATE),
  [stateNames.ROLES_LIST]: createThunkReducer(actionTypes.ROLES_LIST),
}
